export default defineNuxtPlugin({
  setup() {
    const config = useRuntimeConfig()
    const { signOut } = useAuth()
    const api = $fetch.create({
      baseURL: config.app.baseURL,
      onResponseError({ response }) {
        // Si se recibe un error 401 (No autorizado), cerrar sesión y redirigir a login
        if (response.status === 401) {
          console.warn('Error de autenticación 401 - Redirigiendo a login')
          signOut({ callbackUrl: '/auth/login' })
        }
      }
    })

    return {
      provide: {
        api
      }
    }
  }
})
